module.exports = __webpack_public_path__ + "static/2Nestt PRofile -87cd25e6234376bfb28e8f1e9691877c.gif";